import axios from 'axios';

const API_BASE_URL = '/api';

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

const permissionService = {
  async list(resource = 'wqms_dashboard') {
    try {
      const token = localStorage.getItem('token'); // or sessionStorage.getItem('token')
      const r = await client.get('/permissions', {
        params: { resource },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return { success: true, data: r.data.data };
    } catch (e) {
      return { success: false, message: e.response?.data?.message || 'Failed to load permissions' };
    }
  },

  async save({ subjectType, subjectId, permission, resource = 'wqms_dashboard' }) {
    try {
      const token = localStorage.getItem('token'); // or sessionStorage.getItem('token')
      await client.post('/permissions',
        { subjectType, subjectId, permission, resource },
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          withCredentials: true
        }
      );
      return { success: true };
    } catch (e) {
      return { success: false, message: e.response?.data?.message || 'Failed to save permission' };
    }
  },

  async remove({ subjectType, subjectId, resource = 'wqms_dashboard' }) {
    try {
      const token = localStorage.getItem('token'); // or sessionStorage.getItem('token')
      await client.delete('/permissions', {
        data: { subjectType, subjectId, resource },
        headers: {
          Authorization: `Bearer ${token}`
        },
        withCredentials: true
      });
      return { success: true };
    } catch (e) {
      return { success: false, message: e.response?.data?.message || 'Failed to remove permission' };
    }
  }
};

export default permissionService;
